import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import CollapsedCms from '~/client/shared/cms/CollapsedCms';

const GameDescription: FC = () => {
  const { mainBlock, title } = useGameDescription();
  return (
    <div>
      <h2 className="mb-4 text-moon-24 font-medium text-bulma">{title}</h2>
      <CollapsedCms content={mainBlock ?? ''} />
    </div>
  );
};

const useGameDescription = () => {
  const { description } = useGameContext();
  const { mainBlock, title } = description ?? {};
  return { mainBlock, title };
};

export default GameDescription;
